import {IAugmentedJQuery, IController, IModule, INgModelController, IOnChangesObject} from "angular";
import _ from "lodash";
import {regNavn} from "../../tjenester/tredjepartsTjenestenavn";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('OtpInputKontroller');
const css = require('./otpInput.scss');


export class OtpInputKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('fkOtpInput', {
              bindings: {otpValidert: '<'},
              require: {ngModel:'ngModel'},
              controller: OtpInputKontroller.forInjisering(),
              template: require('./otpInput.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$element,
            OtpInputKontroller
        ]
    }


    constructor(private $element:IAugmentedJQuery) {
        const unikId =
          Math.random()
            .toString(36)
            .substring(2) + new Date().getTime().toString(36);

        this.siffer = _(_.fill(Array(6), null)).map((element, indeks) => ({verdi: NaN, id: `otp_${indeks}_${unikId}`})).value();
    }

    otpValidert:boolean; //settes via bindings/$onChanges
    ngModel:INgModelController; //settes via require

    siffer: { verdi: number, id: string }[];
    otpFormatOk = false;
    otp: string;

    onPaste($event){
        debug('onPaste', $event)
        $event.stopPropagation();
        $event.preventDefault();

        let clipboardData = $event.clipboardData || $event.originalEvent.clipboardData || window['clipboardData'];
        if(!clipboardData) return;

        this.initialiserSiffer(clipboardData.getData('text'));
        this.oppdaterModell();
    }

    onKeyDown($event:KeyboardEvent, indeks) {
        debug('onKeyDown %s', indeks, $event)

        this.oppdaterModell();

        //safari vil tilby bruker å kopiere inn engangskode fra sms - dette avsluttes med et "enter"
        //som vi her lytter til for å håndtere innlimt verdi
        //merk at dette også vil føre til submit da vi ikke stopper boblingen av enter-eventet
        if (this.erEnter($event)) return this.håndterMuligAutocomplete($event);

        //lar tab, paste event boble opp
        if (this.erTab($event) || this.erPaste($event)) return;

        $event.preventDefault();
        $event.stopPropagation();

        //navigasjon mellom felter
        if (this.erPilHøyre($event)) return this.gåTilSiffer(indeks+1);
        if (this.erPilVenstre($event)) return this.gåTilSiffer(indeks-1);
        if (this.erBackspaceEllerDelete($event)) {
            this.setSifferVerdi(indeks, NaN);
            this.gåTilSiffer(indeks-1);
            this.oppdaterModell();
            return;
        }

        //oppdater undeliggende felt og modell
        if (this.erGyldigVerdiFraEvent($event)) {
            const tall = this.lesTallFraEvent($event);
            this.setSifferVerdi(indeks, tall);
            this.gåTilSiffer(indeks+1);
            this.oppdaterModell();
            return;
        }
    }

    /** detekter at input-felt har fått verdi og oppdater underliggende modell.
     * Ved feks kjøring av e2e-tester med testwright vil ikke keyPress trigges - change-eventet fyres derimot */
    onChange($event:KeyboardEvent, indeks) {
        debug('onChange %s', indeks, $event)
        const verdi = _.toNumber(angular.element($event.target).val())

        if (!this.erGyldigVerdi(verdi)) {
            debug('ikke gyldig tall %s, indeks %s', verdi, indeks)
            return;
        }

        //oppdater undeliggende felt og modell
        this.setSifferVerdi(indeks, verdi);
        this.gåTilSiffer(indeks + 1);
        this.oppdaterModell();
        debug('modell oppdatert %s, indeks %s', this.otp, indeks)
    }

    $onInit(): void {
        //håndter at modell oppdateres utenifra
        this.ngModel.$render = () => {
            const nyVerdi = this.ngModel.$viewValue;
            if (_.isNil(nyVerdi)) this.blankUt();
            else this.initialiserSiffer(nyVerdi);
            this.beregnModellGyldighet();
        };
        //md-autofocus fungerer kun for elementer i: $mdDialog, $mdBottomSheet, $mdMenu or $mdSidenav opens or upon page load for input-like elements
        //sørger derfor for å sette fokus her
        setTimeout(()=>{
            this.$element.find('.fk-oi-input.md-autofocus').focus();
        })
    }

    $onChanges(changes: IOnChangesObject): void {
        if (changes['otpValidert'])
            this.markerSomOtpValidert(changes['otpValidert'].currentValue === true); //currentValue er undefined når validering ikke har blitt kjørt
    }

    //hjelpemetoder

    private blankUt(){
        if (document.getElementById(this.siffer[0].id) == null) return; //gui har ikke rukket å bli tegnet ut enda..
        for(let i=0; i<this.siffer.length; i++)
            this.setSifferVerdi(i, null);
    }

    private initialiserSiffer(otp:any){
        if (_.isNil(otp)) return;
        const somStreng = _.trim(otp);
        if (!/\d{6}/.test(somStreng)) return;
        _(Array.from(somStreng)).each((verdi, indeks) => {
            if (indeks >= this.siffer.length) return false;//avbryt iterasjon
            this.setSifferVerdi(indeks, parseInt(verdi));
        });
    }

    private håndterMuligAutocomplete($event:KeyboardEvent){
        const felt = <HTMLInputElement>$event.target;
        this.initialiserSiffer(felt.value);
        this.oppdaterModell();
    }

    private erTab(event:KeyboardEvent) {
        return this.erKeyCode(event, 9);
    }

    private erPaste(event:KeyboardEvent) {
        return (event.ctrlKey || event.metaKey) && event.key == 'v';
    }

    private erEnter(event:KeyboardEvent) {
        return this.erKeyCode(event, 13);
    }

    private erPilVenstre(event:KeyboardEvent) {
        return this.erKeyCode(event, 37);
    }

    private erPilHøyre(event:KeyboardEvent) {
        return this.erKeyCode(event, 39);
    }

    private erBackspaceEllerDelete(event:KeyboardEvent) {
        return (
          event.key === 'Backspace' ||
          event.key === 'Delete' ||
          this.erKeyCode(event, 8) ||
          this.erKeyCode(event, 46)
        );
    }

    private erKeyCode(event:KeyboardEvent, targetCode) {
        return (event.keyCode || event.charCode) == targetCode;
    }

    private gåTilSiffer(indeks:number) {
        if (indeks < 0 || indeks >= this.siffer.length) return;
        const element: any = document.getElementById(this.siffer[indeks].id);
        element.focus();
    }

    private setSifferVerdi(indeks:number, verdi:number){
        const siffer = this.siffer[indeks];
        siffer.verdi = verdi;

        (<HTMLInputElement>document.getElementById(siffer.id)).value = _.isFinite(verdi) ? verdi.toString() : '';
    }

    private erGyldigVerdiFraEvent(event:KeyboardEvent) {
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return false;
        const verdi = this.lesTallFraEvent(event);
        return this.erGyldigVerdi(verdi);
    }

    private erGyldigVerdi(verdi:number) {
        const erMobil = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const erGyldigTall = erMobil || _.isFinite(verdi);
        return erGyldigTall;
    }

    private lesTallFraEvent(event:KeyboardEvent):number{
        // se http://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
        if (event.keyCode >= 48 && event.keyCode <= 57) return event.keyCode - 48;
        if (event.keyCode >= 96 && event.keyCode <= 105) return event.keyCode - 96;
        return NaN;
    }

    private oppdaterModell() {
        this.ngModel.$setValidity('otpValidert', null);
        this.beregnModellGyldighet();
        if (!this.otpFormatOk) return;

        this.otp = _(this.siffer).map(siffer => (_.isFinite(siffer.verdi) ? siffer.verdi.toString() : '')).join('');
        this.ngModel.$setViewValue(this.otp);
    }

    private beregnModellGyldighet() {
        this.otpFormatOk = _(this.siffer).every(siffer => _.isFinite(siffer.verdi));
        this.ngModel.$setValidity('otpFormatOk', this.otpFormatOk);
    }

    private markerSomOtpValidert(validert:boolean){
        debug('markerSomOtpValidert', validert)
        this.ngModel.$setValidity('otpValidert', validert);
    }
}

